import * as React from 'react';
import { cn } from '@utils';
import type { ISideNavCollapseToggleProps } from './types';

/**
 * Floating chevron control that expands or collapses the side nav.
 */
export const SideNavCollapseToggle: React.FC<ISideNavCollapseToggleProps> = ({
	collapsed,
	onToggle,
	expandLabel,
	collapseLabel,
	icon,
	className,
}) => {
	return (
		<button
			type="button"
			onClick={onToggle}
			aria-label={collapsed ? expandLabel : collapseLabel}
			aria-expanded={!collapsed}
			data-testid="side-nav-collapse-toggle"
			className={cn(
				'absolute top-[2rem] right-0 z-[1000] flex h-[3.2rem] w-[3.2rem] translate-x-[1.2rem] items-center justify-center',
				'rounded-[0.6rem] border-2 border-primary bg-white text-primary shadow-[0_2px_8px_rgba(0,0,0,0.15)]',
				'transition-colors duration-200 hover:border-accent hover:bg-accent hover:text-white',
				'focus-visible:outline focus-visible:outline-[3px] focus-visible:outline-offset-2 focus-visible:outline-accent',
				'[&>svg]:h-[1.6rem] [&>svg]:w-[1.6rem]',
				className
			)}
		>
			{icon}
		</button>
	);
};

SideNavCollapseToggle.displayName = 'SideNavCollapseToggle';
